/**
 * Shared auth cookie constants and types.
 * Used by both middleware (edge runtime) and client/server code.
 */

import type {
  ExternalAccountID,
  StripeCustomerID,
} from "@repo/db/branded-types";

export const AUTH_COOKIE_NAME = "kinsa-auth";
export const DEBUG_CUSTOMER_PREFIX = "debug_cus_";

export interface AuthCookie {
  externalAccountId: ExternalAccountID;
  customerId?: StripeCustomerID;
}
